import React, { useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { color, radius } from '../../config/tokens';

const getInitial = () => {
  try { return localStorage.getItem('tc-theme') === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
};

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(getInitial);
  const next = theme === 'light' ? 'dark' : 'light';

  const toggle = () => {
    setTheme(next);
    try { localStorage.setItem('tc-theme', next); } catch { /* private mode */ }
    document.documentElement.setAttribute('data-theme', next);
  };

  return (
    <button
      onClick={toggle}
      className="tc-btn"
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        background: 'transparent',
        border: `1px solid ${color.border.default}`,
        borderRadius: radius.md,
        color: color.text.muted,
        cursor: 'pointer',
        flexShrink: 0
      }}
    >
      {/* icon inherits currentColor from the button's color */}
      {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
};

export default ThemeToggle;
